// extracted by mini-css-extract-plugin
export default {"title":"FINI2","advantage":"mN6Ro","icon":"RnUMM","text":"F385I"};